import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import { Heading, SimpleGrid, Spacer, VStack } from "@chakra-ui/react";

import { fetchOrganizations } from "api/webservice/organizations";
import { useUser } from "context/user";
import { AuthenticatedLayout } from "layouts";
import { Organization } from "types/organization";
import { UserRole } from "types/user";
import OrganizationsDataTable from "./OrganizationsDataTable";

const Organizations: React.FC = () => {
  const { user } = useUser()!;
  const [organizations, setOrganizations] = useState<Organization[]>([]);

  const handleFetchOrganizations = (): void => {
    fetchOrganizations().then((response: Organization[]) => {
      if (response) setOrganizations(response);
    });
  };

  useEffect(() => {
    handleFetchOrganizations();
  }, [setOrganizations]);

  if (user.id && user.privs < UserRole.Admin) {
    return <Redirect to={`/organization/${user.organization_id}`} />;
  }

  return (
    <AuthenticatedLayout>
      <VStack alignItems="flex-start" spacing={8}>
        <SimpleGrid columns={3} w="100%">
          <Heading size="lg">Organization Management</Heading>
          <Spacer />
        </SimpleGrid>
        <OrganizationsDataTable organizations={organizations} />
      </VStack>
    </AuthenticatedLayout>
  );
};

export default Organizations;
